import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/company/details/page.tsx");
